import * as React from 'react';
import { ReportFieldDefinition } from "../../../../models";
import Typography from '../../../Typography';
import { TextInputField } from '../../fields';

interface IntegerFieldProps {
    id: string,
    value?: string,
    fieldDefinition: ReportFieldDefinition,
    style?: React.CSSProperties,
    readOnly?: boolean,
    invalid?: boolean,
    onChange?: (value: string) => void,
}

export const IntegerField: React.FC<IntegerFieldProps> = ({
    id,
    value,
    style,
    invalid,
    readOnly,
    onChange,
}) => {
    return readOnly 
        ? <Typography id={id} style={style}>{value}</Typography>
        : <TextInputField id={id} style={style} type="number" pattern="\d+" step="1" invalid={invalid} value={value} onChange={onChange} disabled={readOnly}/>
}